import React, { useEffect, useState } from 'react';
import { Row, Col, Button, Breadcrumb, Form, Card, Input, Upload, Select, message, Image, Spin } from 'antd';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import { PlusOutlined } from '@ant-design/icons';
import { COOKIE, getCookie } from '../../../../services/cookie';
import { fetchAdminApi } from '../../../../services/api';
import constants from '../../../../constants/constants';
import { getCustomisedBreadcrumbs } from '../../../../functions/functions';
const { Dragger } = Upload;

function EditVideo() {
	const [form] = Form.useForm();
	const [messageApi, contextHolder] = message.useMessage();
	const navigate = useNavigate();
	const location = useLocation() || {};
	const { chapterId, entireRecord } = location.state || {};
	const [chapterid, setChapterid] = useState(chapterId);
	const [resourceid, setresourceId] = useState('');
	const [captionText, setCaptiontext] = useState('');
	const [details, setDetails] = useState('');
	// const [imageurl, setImageurl] = useState('');
	const [thumbimageurl, setThumbimageurl] = useState('');
	const [imagename, setImagename] = useState('');
	// const [originalImage, setOriginalimage] = useState('');
	const [videoinfo, setVideoinfo] = useState([]);
	const [allchapters, setAllchapters] = useState([]);
	const [defaultid, setDefaultId] = useState('');
	const [fileList, setFileList] = useState([{
		uid: '-1',
		status: 'done',
		url: thumbimageurl,
		thumbUrl: thumbimageurl,
		name: imagename,
	}])
	const [videoloading, setVideoloading] = useState(false);

	useEffect(() => {
		let userId = getCookie(COOKIE.UserId);
		if (!userId) {
			navigate('/admin-login');
		}
	}, []);

	const newCrumb = [<Link key={0} to="/video-list" className="font-semibold">Videos</Link>, <Link key={0} to={`/editVideo`} className="font-semibold !text-black">Edit Video</Link>]
	const changeCaptiontext = (e) => {
		setCaptiontext(e.target.value);
	}
	const changeDetails = (e) => {
		setDetails(e.target.value);
	}
	const props = {
		defaultFileList: [...fileList]
	}
	const changeVideo = (info) => {
		let fileList = [...info.fileList];
		fileList = fileList.slice(-1);
		setFileList(fileList);
	}
	const getImage = (e) => {
		setVideoinfo(e?.fileList);
		if (Array.isArray(e)) {
			return e;
		}
		return e?.fileList;
	}
	const getchapters = () => {
		const chapters = JSON.parse(localStorage.getItem('chapterDetails'))
		if (chapters && chapters != '') {
			setAllchapters(chapters)
		}
	}
	useEffect(() => {
		getVideoDetails()
	}, [])
	useEffect(() => {
		if (chapterId && chapterId != '') {
			setChapterid(chapterId);
			setresourceId(entireRecord.resource_file_id);
		}
		getchapters();
		if (allchapters && allchapters != '') {
			setDefaultId(allchapters.filter((el) => { return el.value == chapterId }))
		}
	}, [resourceid])
	const getVideoDetails = () => {
		if (chapterId && chapterId != '') {
			fetchAdminApi(`/get-video-info?resource_id=${Number(entireRecord.resource_file_id)}`, 'get').then((res) => {
				if (res && res != '') {
					setCaptiontext(res.data ? res.data[0].caption : '');
					setDetails(res.data ? res.data[0].details : '');
					// setImageurl(res.data ? res.data[0].resource_name : '');
					setThumbimageurl(res.data ? res.data?.[0]?.thumbnail : '');
					setImagename(res.data ? res.data[0].resource_name : '');
					// setOriginalimage(res.data ? res.data[0].original_name : '');
					setFileList((prev) => [{
						uid: '-1',
						status: 'done',
						url: res.data[0].resource_name,
						thumbUrl: res.data[0].thumbnail,
						name: res.data[0].resource_name
					}]
					)
					form.setFieldsValue({
						caption: res.data?.[0]?.caption,
						image: res.data?.[0].thumbnail,
						category: res?.data?.[0]?.category
					})
				}
			})
		}
	}
	const changeImageChapterid = (value) => {
		setChapterid(value);
		setDefaultId(value);
		const chapterEdited = true;
		localStorage.setItem('chapterEdited', chapterEdited);
		localStorage.setItem('vidChapterchangeId', value);
	}
	const submitInfo = async (values) => {
		try {
			setVideoloading(true);
			let categoryid = form.getFieldValue("category");
			const formData = new FormData();
			if (videoinfo.length == 0) {
				formData.append('title', values.caption);
				formData.append('updated_by', 1);
				formData.append('resource_type', 2);
				formData.append('chapter_id', chapterid);
				formData.append('resource_id', resourceid);
				formData.append('category', categoryid);
			} else {
				videoinfo.forEach((file) => {
					formData.append('file', file.originFileObj);
				});
				formData.append('title', values.caption);
				formData.append('updated_by', 1);
				formData.append('resource_type', 2);
				formData.append('chapter_id', chapterid);
				formData.append('resource_id', resourceid);
				formData.append('category', categoryid);
			}

			const response = await fetch(`${constants.AdminApiUrl}/upload-video`, {
				method: 'POST',
				body: formData,
				headers: {
					Authorization: `Bearer ${getCookie(COOKIE.Token)}`
				},
			});
			const data = await response.json();
			if (data.code === 200) {
				setVideoloading(false);
				const editimageConfirmation = true;
				localStorage.setItem('videoEdited', editimageConfirmation);
				localStorage.setItem('vidChapterId', chapterId);
				navigate(`/get-chapter-videos/${chapterid}`, { state: { chapterId: chapterid } });
				form.resetFields();

			} else {
				message.error(constants.video_added_failure);
				setVideoloading(false);
			}
		} catch (error) { 
			setVideoloading(false);
		}
	}

	const redirectBack = () => {
		navigate(-1);
	}

	return (
		<div className="cursorChange">
			<Row>
				<Col xs={24} sm={24} md={24} lg={24}>
					<div className='p-4 min-h-screen bg-gray-100'>
						<div>
							<Breadcrumb
								items={getCustomisedBreadcrumbs(constants.flashCardpageCrumbs, newCrumb)}
								className='bg-neutral-100 shadow-lg p-3 mb-3' />
						</div>
						<Card
							className='mainflashCard'
							title={<div className='flex-space'><span className="mr-8">EDIT VIDEO</span>
								<Select
									value={chapterid}
									onChange={changeImageChapterid}
									className='w-80'
								>
									<Option disabled value=""> --Chapter-- </Option>
									{
										allchapters.map((each) => {
											return <Option disabled key={each.value} value={
												each.value.toString()
											}> {each.label} </Option>
										})
									}
								</Select>
							</div>
							}
							extra={<div className="font-medium text-xl text-pink-600">Video  #{resourceid}</div>}
							hoverable>
							<Spin spinning={videoloading} size="large" className='z-30'>
								<Form
									form={form}
									onFinish={submitInfo}
									onFinishFailed={
										() => {
											message.error(constants.video_added_failure);
										}
									}
								>
									<Card hoverable>
										<Form.Item
											label={<span
												className="font-semibold text-base caption-item pr-2 imagecardTitle">{constants.Category}</span>}
											className='caption-form-item'
											name="category"
											rules={
												[{
													required: true,
													message: 'This field is mandatory!'
												}
												]
											}
										>
											<Select
												className='w-full rounded-md'
												placeholder={constants.Category}
												style={{ width: '70%' }}
											>
												{constants.VideoCategoryList.map((option) => (
													<Select.Option key={option.id} value={option.id}>
														{option.title}
													</Select.Option>
												))}
											</Select>
										</Form.Item>
									</Card>
									<Card hoverable className='mt-5'>
										<Form.Item
											label={<span
												className="font-semibold text-base caption-item pr-2 imagecardTitle">Caption</span>}
											className='caption-form-item'
											name="caption"
											rules={
												[{
													required: true,
													message: 'This field is mandatory!'
												},
												{
													validator: (_, value) =>
														value != '' && value != "<p><br></p>" ? Promise.resolve() : Promise.reject(new Error('This field is mandatory!')),
												},
												]
											}
										>
											<Input type='text' style={{ width: '70%' }} value={captionText} onChange={changeCaptiontext}></Input>
										</Form.Item>
									</Card>
									<Card className='mt-5' hoverable>
										<Form.Item
											getValueFromEvent={getImage}
											action="/upload.do"
											label={<span
												className="font-semibold text-base image-item pr-3 imagecardTitle">Video</span>
											}
											name="image"
											className="image-form-item"
											rules={
												[{
													required: true,
													message: 'This field is mandatory!'
												},
												]
											}
										>
											<Dragger
												name="files"
												action=""
												listType="picture"
												fileList={[...fileList]}
												onChange={changeVideo}
												maxCount={1}
												accept=".mp4"
												beforeUpload={
													(file) => {
														const ismp4 = file.type === 'mp4';
														if (!ismp4) {
															success('error', 'Error!Only allowed extensions are mp4...', 'flashSuccess', messageApi);
														}
													}
												}
												{...props}>
												<p className="ant-upload-drag-icon"><PlusOutlined /></p>
												<p className="ant-upload-text"> {constants.chooseVideo} </p>
											</Dragger>
										</Form.Item>
										{/* <Form.Item name="smallImage" className="basis-1/5 ml-3">
										<Image
											src={thumbimageurl}
										/>
									</Form.Item> */}
									</Card>
									{/* <Card className="flex justify-start items-center mt-2" hoverable>
									<Form.Item name="originalimage"
									>
										<Image
											src={originalImage}
										/>
									</Form.Item>
								</Card> */}
									<Button htmlType='submit' type="primary" className='mt-5 font-semibold'>Submit</Button>
									<Button type="primary" className='mt-5 ml-3 font-semibold' onClick={redirectBack}>Cancel</Button>
									{contextHolder}
								</Form>
							</Spin>
						</Card>
					</div>
				</Col>
			</Row>
		</div>
	)
}

export default EditVideo
